module.exports = __webpack_public_path__ + "static/media/Group_1000006766.4a0c3861.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_174/img/Group_1000006766.png
// module id = 1609
// module chunks = 0